/**
 * Auxalia Design System Theme — Admin Panel
 * Navy (#00263E) + Lime (#A7D500)
 */
import type { ThemeConfig } from 'antd'

export const auxaliaColors = {
  lime: '#A7D500',
  limeLight: '#E8F5B3',
  limeDark: '#8BB800',
  navy: '#00263E',
  navyLight: '#1a4058',
  navyDark: '#001a2a',
  white: '#FFFFFF',
  grayLightest: '#F9FAFB',
  grayLighter: '#F3F4F6',
  grayLight: '#E5E7EB',
  grayMedium: '#9CA3AF',
  grayDark: '#6B7280',
  grayDarker: '#4B5563',
  success: '#A7D500',
  error: '#EF4444',
  warning: '#F59E0B',
  info: '#3B82F6',
  border: '#E5E7EB',
  borderLight: '#EEEEEE',
  textPrimary: '#00263E',
  textSecondary: '#6B7280',
  textTertiary: '#9CA3AF',
}

export const adminTheme: ThemeConfig = {
  token: {
    colorPrimary: auxaliaColors.lime,
    colorPrimaryBg: auxaliaColors.limeLight,
    colorPrimaryBgHover: auxaliaColors.limeLight,
    colorPrimaryBorder: auxaliaColors.lime,
    colorPrimaryHover: auxaliaColors.limeDark,
    colorPrimaryActive: auxaliaColors.limeDark,
    colorSuccess: auxaliaColors.success,
    colorSuccessBg: auxaliaColors.limeLight,
    colorError: auxaliaColors.error,
    colorErrorBg: '#FEF2F2',
    colorWarning: auxaliaColors.warning,
    colorWarningBg: '#FFFBEB',
    colorInfo: auxaliaColors.info,
    colorInfoBg: '#EFF6FF',
    colorBgContainer: auxaliaColors.white,
    colorBgLayout: auxaliaColors.grayLightest,
    colorBorder: auxaliaColors.border,
    colorBorderSecondary: auxaliaColors.borderLight,
    colorText: auxaliaColors.textPrimary,
    colorTextSecondary: auxaliaColors.textSecondary,
    colorTextTertiary: auxaliaColors.textTertiary,
    colorLink: auxaliaColors.navy,
    colorLinkHover: auxaliaColors.lime,
    colorLinkActive: auxaliaColors.limeDark,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    fontSize: 14,
    borderRadius: 6,
    borderRadiusLG: 8,
    borderRadiusSM: 4,
    controlHeight: 36,
    controlHeightLG: 40,
    controlHeightSM: 28,
  },
  components: {
    Button: {
      primaryColor: auxaliaColors.white,
      defaultBg: auxaliaColors.white,
      defaultBorderColor: auxaliaColors.border,
      defaultColor: auxaliaColors.textPrimary,
      fontWeight: 500,
    },
    Menu: {
      itemSelectedBg: auxaliaColors.limeLight,
      itemSelectedColor: auxaliaColors.navy,
      itemHoverBg: auxaliaColors.grayLighter,
      itemHoverColor: auxaliaColors.navy,
      itemActiveBg: auxaliaColors.limeLight,
      itemBg: 'transparent',
      subMenuItemBg: 'transparent',
      groupTitleColor: auxaliaColors.textSecondary,
      groupTitleFontSize: 11,
    },
    Table: {
      headerBg: auxaliaColors.grayLightest,
      headerColor: auxaliaColors.navy,
      headerSplitColor: auxaliaColors.border,
      rowHoverBg: auxaliaColors.grayLightest,
      borderColor: auxaliaColors.border,
    },
    Card: {
      paddingLG: 16,
      borderRadiusLG: 8,
    },
    Input: {
      activeBorderColor: auxaliaColors.navy,
      hoverBorderColor: auxaliaColors.grayDark,
    },
    Select: {
      optionSelectedBg: auxaliaColors.limeLight,
      optionSelectedColor: auxaliaColors.navy,
    },
    Modal: {
      titleFontSize: 18,
      titleColor: auxaliaColors.navy,
    },
    Breadcrumb: {
      itemColor: auxaliaColors.textSecondary,
      lastItemColor: auxaliaColors.textPrimary,
      linkColor: auxaliaColors.textSecondary,
      linkHoverColor: auxaliaColors.lime,
      separatorColor: auxaliaColors.textTertiary,
    },
    Tabs: {
      itemSelectedColor: auxaliaColors.navy,
      itemHoverColor: auxaliaColors.lime,
      inkBarColor: auxaliaColors.lime,
    },
    Layout: {
      siderBg: auxaliaColors.navy,
      headerBg: auxaliaColors.white,
      bodyBg: auxaliaColors.grayLighter,
    },
  },
}
